/**
 * Shared utility functions for Command Center components
 */

import { formatCount } from '../../utils/numberUtils';

/**
 * Formats exact, locale-grouped used/total counts (e.g., "1,500 / 10,000").
 */
export const formatUsageLabel = (used: number, total: number): string => {
  return `${formatCount(used)} / ${formatCount(total)}`;
};

/**
 * Calculates usage percentage
 */
export const calcPercentage = (used: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((used / total) * 100);
};

/**
 * Checks if a field label indicates it contains secret data
 */
export const isSecretField = (label: string): boolean => {
  const lowerLabel = label.toLowerCase();
  return lowerLabel.includes('key') || lowerLabel.includes('secret') || lowerLabel.includes('password');
};
